import { Component } from 'react';
import { Button } from 'edrolo-style-guide';
import styles from './WorkedQuestion.scss';
import WistiaUtils from 'edrolo/utils/WistiaUtils';
import { EXAM_QUESTION_TYPES } from 'edrolo/constants/QuestionTypes';
import QuestionSolution from '../../../QuestionSolution';
import GrokSelfReflection from '../../../GrokSelfReflection';
import questionTypePropInterface from '../../questionTypePropInterface';
import { SelfMarking } from '../SelfMarking';
import { WaffleFlag } from 'edrolo/utils/Waffle';

class WorkedQuestion extends Component {
  render() {
    const {
      question,
      response,
      onSubmit,
      onSubmitGrok,
      onSubmitMark,
      grokkingItemIsSaving,
      onSubmitTeacherAnswer,
    } = this.props;

    return (
      <>
        {!response ? (
          <div data-test={`question-${EXAM_QUESTION_TYPES.WORKED}`}>
            <p className={styles.paperPrompt}>
              Please complete this question with pen and paper
            </p>
            <Button
              onClick={() =>
                onSubmitTeacherAnswer
                  ? onSubmitTeacherAnswer()
                  : onSubmit({ submittedText: '' })
              }
              data-test={`submit-${EXAM_QUESTION_TYPES.WORKED}`}
            >
              {onSubmitTeacherAnswer
                ? 'View answer'
                : 'Iʼm ready to see the solution'}
            </Button>
          </div>
        ) : (
          <div data-test={`answer-${EXAM_QUESTION_TYPES.WORKED}`}>
            <QuestionSolution
              headingText="Solution"
              questionId={question.get('id')}
              explanation={response.getIn(['solution', 'explanation'])}
              videoHash={response.getIn([
                'solution',
                'video',
                'wistia_hashed_id',
              ])}
              videoThumbnailUrl={WistiaUtils.getThumbnail(
                response.getIn(['solution', 'video'])
              )}
            />

            <p className={styles.paperPrompt}>Completed with pen and paper</p>

            <WaffleFlag name={'questions-self-marking'}>
              <SelfMarking
                onChange={onSubmitMark}
                mark={response.get('text_marks_from_student')}
                totalMarks={Number(question.get('marks'))}
              />
            </WaffleFlag>

            <GrokSelfReflection
              value={response.get('grokked')}
              onChange={onSubmitGrok}
              isSaving={grokkingItemIsSaving}
              className={styles.selfReflection}
            />
          </div>
        )}
      </>
    );
  }
}

WorkedQuestion.propTypes = {
  ...questionTypePropInterface,
};

export { WorkedQuestion };
